/**
 * Onboarding Helper Functions
 *
 * Separated from Onboarding.tsx for fast refresh compatibility.
 */

import type { OnboardingData } from './types';
import { getValidatedItem, setStorageItem, removeStorageItem, getStorageString, STORAGE_KEYS } from '../../lib/storageService';
import { OnboardingDataSchema } from '../../lib/schemas';

/**
 * Check if user has completed onboarding
 */
export function hasCompletedOnboarding(): boolean {
  return getStorageString(STORAGE_KEYS.ONBOARDING) !== null;
}

/**
 * Get stored onboarding data
 */
export function getOnboardingData(): OnboardingData | null {
  return getValidatedItem(STORAGE_KEYS.ONBOARDING, OnboardingDataSchema, null) as OnboardingData | null;
}

/**
 * Reset onboarding (for settings page)
 */
export function resetOnboarding(): void {
  removeStorageItem(STORAGE_KEYS.ONBOARDING);
}

/**
 * Save onboarding data
 */
export function saveOnboardingData(data: OnboardingData): void {
  setStorageItem(STORAGE_KEYS.ONBOARDING, data);
}
